import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Tabs, Tab } from "material-ui/Tabs";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import { Page, Loadable, IconButton } from "components/support";

import { colors } from "assets";

import ProductGeneralInfo from "./general-info";
import ProductSkuInfo from "./sku";
import ProductFiscalInfo from "./fiscal-info";
import ProductStockInfo from "./stock-info";
import ProductKitInfo from "./kit-info";

export default class ProductInfoView extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const {
      loading,
      product,
      defaultConfiguration,
      linkedOptionalGroups,
      variationsList,
      variationsListOptions,
      selectedVariations,
      hasSku,
      skuResultSet,
      skuLoading,
      company
    } = viewModel;

    const hasManageSellable = company.features.includes("manage_sellable");

    return (
      <Page>
        <Row>
          <Col xs={12}>
            <Typography type="display1" className="pb-sm">
              <Row>
                <Col xs>
                  <IconButton
                    icon="arrow_back"
                    onClick={() => presenter.onGoBack()}
                  />
                  {product.identifier()}
                </Col>
                {hasManageSellable && (
                  <Col>
                    <IconButton
                      icon="mode_edit"
                      onClick={() => presenter.onEdit()}
                    />
                    <IconButton
                      icon="delete"
                      onClick={() => presenter.onRequestDelete()}
                    />
                  </Col>
                )}
              </Row>
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <Paper elevation={1}>
                <Tabs
                  inkBarStyle={{ backgroundColor: colors.accent.normal }}
                  tabItemContainerStyle={{
                    backgroundColor: colors.primary.dark
                  }}
                >
                  <Tab label="Informações Gerais" className="tab-content">
                    <ProductGeneralInfo
                      product={product}
                      linkedOptionalGroups={linkedOptionalGroups}
                      variationsList={variationsList}
                      variationsListOptions={variationsListOptions}
                      selectedVariations={selectedVariations}
                    />
                  </Tab>
                  {hasSku ? (
                    <Tab label="SKUs" className="tab-content">
                      <ProductSkuInfo
                        product={product}
                        hasSku={hasSku}
                        skuLoading={skuLoading}
                        skuResultSet={skuResultSet}
                      />
                    </Tab>
                  ) : null}
                  <Tab label="Informações Tributárias" className="tab-content">
                    <ProductFiscalInfo
                      product={product}
                      defaultConfiguration={defaultConfiguration}
                    />
                  </Tab>
                  {product.type === "product_kit" ? (
                    <Tab label="Kit/Combo" className="tab-content">
                      <ProductKitInfo product={product} />
                    </Tab>
                  ) : (
                    <Tab label="Informações de Estoque" className="tab-content">
                      <ProductStockInfo product={product} />
                    </Tab>
                  )}
                </Tabs>
              </Paper>
            </Loadable>
          </Col>
        </Row>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/info/view.jsx